import apiClient from './client'
import type {
  ExecutionTemplate,
  CreateExecutionTemplateDto,
  UpdateExecutionTemplateDto
} from '@/types/execution-template'

export const executionTemplatesApi = {
  list: async (options?: {
    scriptId?: string
    limit?: number
    offset?: number
  }): Promise<{
    templates: ExecutionTemplate[]
    pagination: {
      total: number
      limit: number
      offset: number
      hasMore: boolean
    }
  }> => {
    const params = new URLSearchParams()
    if (options?.scriptId) params.append('scriptId', options.scriptId)
    if (options?.limit) params.append('limit', options.limit.toString())
    if (options?.offset) params.append('offset', options.offset.toString())

    const response = await apiClient.get(`/execution-templates?${params.toString()}`)
    return response.data
  },

  create: async (template: CreateExecutionTemplateDto): Promise<{
    success: boolean
    template: ExecutionTemplate
  }> => {
    const response = await apiClient.post('/execution-templates', template)
    return response.data
  },

  update: async (id: string, template: UpdateExecutionTemplateDto): Promise<{
    success: boolean
    template: ExecutionTemplate
  }> => {
    const response = await apiClient.put(`/execution-templates/${id}`, template)
    return response.data
  },

  delete: async (id: string): Promise<{
    success: boolean
  }> => {
    const response = await apiClient.delete(`/execution-templates/${id}`)
    return response.data
  },
}